// extracted by mini-css-extract-plugin
module.exports = {"form":"addUserCustomer_form__1xGHj","formGroup":"addUserCustomer_formGroup__KkRwD","heading":"addUserCustomer_heading__1JJj6","formFields":"addUserCustomer_formFields__1eWHt"};